import React, { createContext, useState } from "react";

const UrlServicesContext = createContext();
const { Provider, Consumer } = UrlServicesContext;

function UrlServicesProvider({ children }) {
  /* ### API ### */
  const [urlServices] = useState("http://consultas.usameweb.com/routes/");
  //const [urlServices] = useState("http://api.consulta.usameweb.com/routes/");
  //const [urlServices] = useState("http://localhost/usame_services/routes/");

  /* ### LOAD SERVICES KEYAPLICATION */
  const [keyAplication] = useState("OGMGDuYv3QRwtzUQOpge");

  return (
    <Provider
      value={{
        urlServices,
        keyAplication,
      }}
    >
      {children}
    </Provider>
  );
}

export {
  UrlServicesProvider,
  Consumer as urlServicesConsumer,
  UrlServicesContext,
};
